/** Project Page API — Faz 1.4 createApi factory. */
import {createApi} from './_factory'
import type {CommonNs, FeatureNs} from '@shared/types'

const api = createApi('project-page')

export const ProjectPageApi = {
  getAllProjectPage: (data: FeatureNs.GetAllProjectPageRequest) =>
    api.post<FeatureNs.GetAllProjectPageRequest, FeatureNs.ProjectPage[]>('get-all', data),
  deleteProjectPage: (data: FeatureNs.UpdateProjectPageRequest) =>
    api.post<FeatureNs.UpdateProjectPageRequest, FeatureNs.ProjectPage>('delete-page', data),
  addNewProjectPage: (data: FeatureNs.UpdateProjectPageRequest) =>
    api.post<FeatureNs.UpdateProjectPageRequest, FeatureNs.ProjectPage>('add-page', data),
  /** Bulk insert — BUILDER /insert akışı tarafından çağrılır. */
  addProjectPagesBulk: (data: FeatureNs.UpdateProjectPageRequest) =>
    api.post<FeatureNs.UpdateProjectPageRequest, FeatureNs.ProjectPage[]>('add-pages-bulk', data),
  updateProjectPage: (data: FeatureNs.UpdateProjectPageRequest) =>
    api.post<FeatureNs.UpdateProjectPageRequest, CommonNs.AnyResponse>('update-page', data),
  updateProjectPageOrder: (data: FeatureNs.UpdateProjectPageRequest) =>
    api.post<FeatureNs.UpdateProjectPageRequest, CommonNs.AnyResponse>('update-page-order', data),
}
